function nodeListToArray<T>(nodes: NodeList): Array<T> {
    return [].slice.call(nodes);
}

export { nodeListToArray };


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/nodelist-to-array.ts